/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Gender/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Gender({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/PatientSelect/Content/Content/New/Gender",
  onChange
  
}) {
let gendersValueData = fromData.useDataValue({ viewPath,
context: 'genders',
})
let appointmentOverlayPatientNewPersonGenderValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'patient_new.person.gender',
})
let appointmentOverlayPatientNewPersonGenderChangeData = fromData.useDataChange({ viewPath,
context: 'appointment_overlay',
path: 'patient_new.person.gender',
})
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 marginTop={0}
 size="medium"
 required={true}
 data="genders"
 from={gendersValueData}
 data="appointment_overlay.patient_new.person.gender"
 value={appointmentOverlayPatientNewPersonGenderValueData}
 onChange={appointmentOverlayPatientNewPersonGenderChangeData}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Gender"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}